module.exports = __webpack_public_path__ + "static/media/sword-laser-alt.eaa4c53e.svg";